<template>
  <VaNavbar class="app-layout-navbar px-0 py-2">
    <template #left>
      <div class="left flex items-center gap-2 pl-2">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>

        <img :src="Logo" alt="Logo RoleDeBoa" class="size-8" />
      </div>
    </template>

    <template #right>
      <ProfileDropdown />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import ProfileDropdown from './ProfileDropdown.vue'

import Logo from '@/assets/icon_black.svg'
import { useGlobalStore } from '@/stores/global-store'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const globalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(globalStore)
</script>
